export default "__VITE_ASSET__09e54dd3__"